import React from 'react';
import BackButton from './BackButton';
import FilterByTopic from './FilterByTopic';
import FilterByProgress from './FilterByProgress';

const Sidebar = () => (
  <div className="LearnDashboardSidebar">
    <div className="LearnDashboardSidebar-backButton">
      <BackButton />
    </div>
    <FilterByTopic />
    <FilterByProgress />
  </div>
);

export default Sidebar;
